import { useNotificationsContext } from "common/context/NotificationsProvider"
import { Button } from "primereact/button"
import { useTranslation } from "react-i18next"
import "../style.scss"

const NotificationsHeader = () => {
  const { t } = useTranslation()
  // @ts-expect-error TS(2339): Property 'markAllNotificationsAsRead' does not exi...
  const { markAllNotificationsAsRead, unReadNotifications } =
    useNotificationsContext()

  return (
    <div className='pt-4 pb-4 notifications-header d-flex justify-content-center'>
      <div className='text-left notifications-header-container w-100 d-flex flex-column'>
        <div className='mb-2 notifications-header-title w-100'>
          {t("notifications.header.title")}
        </div>
        <div className='flex-row flex-wrap pr-2 w-100 d-flex justify-content-between'>
          <div className='my-auto notifications-header-subtitle'>
            {t("notifications.header.subtitle")}
          </div>
          {unReadNotifications.totalCount > 0 && (
            <Button
              className='p-0 p-button-text notifications-actions'
              onClick={markAllNotificationsAsRead}
            >
              {t("notifications.header.markAllRead")}
            </Button>
          )}
        </div>
      </div>
    </div>
  )
}

export default NotificationsHeader
